import {useTranslation} from './useTranslation';

export function getCalendarProperties() {
    const {msg} = useTranslation();

    return {
        placeholder: msg('generic.form.date.human.pattern'),
        datePattern: msg('generic.form.date.java.pattern'),
        datePatternRegex: msg('generic.form.date.pattern'),
    };
}
